import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Reminders from './components/Reminders';

const reminders = (props,{ t }) => (
  <Container>
    <Reminders {...props} />
  </Container>
);

reminders.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(reminders);
